import { render } from "./AdminReleaseContent.vue?vue&type=template&id=cc1cd164&scoped=true&ts=true"
import script from "./AdminReleaseContent.vue?vue&type=script&lang=ts"
export * from "./AdminReleaseContent.vue?vue&type=script&lang=ts"

import "./AdminReleaseContent.vue?vue&type=style&index=0&id=cc1cd164&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc1cd164"]])

export default __exports__